<template>
	<v-container grid-list-xl class="container--box white--text">
		<v-layout row wrap>
			<v-flex xs12 md12>
				<h2 class="py-5">{{ $t("title.book_an_event") }}</h2>
			</v-flex>
			<v-flex xs12 md12>
				<v-row>
					<v-col
						v-for="(event, i) in events"
						:key="i"
						cols="12"
						md="6"
						class="d-flex flex-column"
					>
						<v-card class="mx-auto my-0" @click="view(event)">
							<v-card-title class="mb-0">
								<span
									class="d-inline-block text-truncate"
									style="max-width: 550px"
									>{{ event.envet_title }}
								</span></v-card-title
							>

							<v-card-text class="mt-0">
								<div>
									{{ event.start_time_formatted }} -
									{{ event.end_time_formatted }}
								</div>
							</v-card-text>

							<v-img
								height="250"
								:src="
									event && event.image_url
										? event.image_url
										: image_placeholder
								"
							></v-img>
						</v-card>
					</v-col>
				</v-row>
			</v-flex>
		</v-layout>
		<v-dialog
			v-model="dialog"
			transition="dialog-bottom-transition"
			persistent
			max-width="700px"
			scrollable
		>
			<v-card class="mx-auto">
				<v-img
					height="250"
					:src="
						event && event.image_url
							? event.image_url
							: image_placeholder
					"
				></v-img>

				<v-card-title>{{ event.envet_title }}</v-card-title>
				<v-divider class="mx-4"></v-divider>

				<v-card-text>
					{{ event.envet_description }}
				</v-card-text>

				<v-card-text>
					<v-list subheader two-line>
						<v-list-item v-if="event.type == 'everyday'">
							<v-list-item-icon>
								<v-icon color="secondary" large
									>mdi-calendar</v-icon
								>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="text-capitalize">{{
									event.type
								}}</v-list-item-title>

								<v-list-item-subtitle
									>{{ event.start_time_formatted }} -
									{{
										event.end_time_formatted
									}}</v-list-item-subtitle
								>
							</v-list-item-content>
						</v-list-item>
						<v-list-item v-if="event.type == 'day'">
							<v-list-item-icon>
								<v-icon color="secondary" large
									>mdi-calendar</v-icon
								>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="text-capitalize">
									<p v-if="event.mon">Monday</p>
									<p v-if="event.tue">Tuesday</p>
									<p v-if="event.wed">Wednesday</p>
									<p v-if="event.thu">Thursday</p>
									<p v-if="event.fri">Friday</p>
									<p v-if="event.sat">Saturday</p>
									<p v-if="event.sun">Sunday</p>
								</v-list-item-title>
							</v-list-item-content>
							<v-list-item-action>
								<p>
									<span class="mb-2"
										>Start:
										{{ event.start_time_formatted }}</span
									>
									<br />
									End: {{ event.end_time_formatted }}
								</p>
							</v-list-item-action>
						</v-list-item>
						<v-list-item v-if="event.type == 'weekends_only'">
							<v-list-item-icon>
								<v-icon color="secondary" large
									>mdi-calendar</v-icon
								>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="text-capitalize"
									>Weekend Only</v-list-item-title
								>

								<v-list-item-subtitle
									>{{ event.start_time_formatted }} -
									{{
										event.end_time_formatted
									}}</v-list-item-subtitle
								>
							</v-list-item-content>
						</v-list-item>
						<v-list-item v-if="event.type == 'date_range'">
							<v-list-item-icon>
								<v-icon color="secondary" large
									>mdi-calendar</v-icon
								>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="text-capitalize">{{
									event.start_date_formatted
								}}</v-list-item-title>

								<v-list-item-subtitle>
									Start Date |
									{{ event.start_time_formatted }} -
									{{
										event.end_time_formatted
									}}</v-list-item-subtitle
								>
							</v-list-item-content>

							<v-list-item-content>
								<v-list-item-title class="text-capitalize">{{
									event.end_date_formatted
								}}</v-list-item-title>

								<v-list-item-subtitle>
									End Date |
									{{ event.start_time_formatted }} -
									{{
										event.end_time_formatted
									}}</v-list-item-subtitle
								>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card-text>

				<v-card-actions>
					<v-btn
						color="deep-purple lighten-2"
						text
						@click="closeItem()"
					>
						{{ $t("Close") }}
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn
						@click="$inertia.visit($route('reservation.tenants'))"
						dark
						color="secondary"
						>{{ $t("label.make_a_reservation") }}</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
export default {
	props: ["events"],
	data() {
		return {
			image_placeholder: this.$page.props.assets.image_placeholder,
			dialog: false,
			event: {},
		};
	},
	methods: {
		view(event) {
			this.event = Object.assign({}, event);
			this.dialog = true;
		},
		closeItem() {
			this.event = Object.assign({}, {});
			this.dialog = false;
		},
	},
};
</script>